import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {
  CreateSubject ({ state }, course) {
    let obj = course
    return new Promise((resolve, reject) => {
      axios.post('subject/createSubject', obj)
        .then(response => {
          resolve(response.data)
          course = {}
        }).catch((err) => {
          reject(err)
        })
    })
  },
  getUserList ({ state, commit }) {
    axios.get('user/getUserList')
      .then(response => {
        state.userList = response.data
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  getUserDetails ({ state, commit }, id) {
    axios.get('user/getUserDetails/' + id)
      .then(response => {
        state.userDetail = response.data
        this.searchByCode()
      // eslint-disable-next-line handle-callback-err
      }).catch((err) => {
      })
  },
  searchByCode ({ state, commit }) {
    if (state.payment.user_id && state.payment.code) {
      axios.get('search/searchByCode/' + state.payment.code + '/' + state.payment.user_id)
        .then(response => {
          state.itemForPayment = response.data
        // eslint-disable-next-line handle-callback-err
        }).catch((err) => {
        })
    }
  },
  purchaseList ({ state, commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post('payment/purchaseList', obj)
        .then(response => {
          resolve(response.data)
        }).catch((err) => {
          reject(err)
        })
    })
  }

}
